import axiosPost from "../axiosPost";

export const zonaIns = async ({
    gateZonaCod,
    gateZonaNombre,
    gateZonaGlobal
}, credentials) => {
    const body = {
        service: "GateZonaIns",
        params: {
            merchantId: credentials.merchantId,
            gateZonaCod,
            gateZonaNombre,
            gateZonaGlobal
        },
    };

    return await axiosPost(body, credentials);
};
